import { render, staticRenderFns } from "./bookCommentAll.vue?vue&type=template&id=fdfde070&scoped=true"
import script from "./bookCommentAll.vue?vue&type=script&lang=js"
export * from "./bookCommentAll.vue?vue&type=script&lang=js"
import style0 from "./bookCommentAll.vue?vue&type=style&index=0&id=fdfde070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfde070",
  null
  
)

export default component.exports